import Accordion from '@/common/components/Accordion'
import GeoSelectOption from '@/common/components/GeoSelectOption'
import { dateTransformer } from '@/common/utils/dateTransformer'
import { CompanyContractType } from '@/features/privateCompanies/types/companyContract.type'
import { CalendarDaysIcon, CircleChevronDownIcon } from 'lucide-react'
import { UpdateContractGeneralInformationModal } from '../updateContract/UpdateContractGeneralInformationModal'

type ContractGeneralInformationProps = {
  contract?: CompanyContractType
}

export const ContractGeneralInformation = ({ contract }: ContractGeneralInformationProps) => {
  return (
    <Accordion
      defaultOpen
      name="contract_general_information"
      head={
        <div className="flex items-center gap-x-2">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateContractGeneralInformationModal contract={contract} />
          </div>

          <p className="text-white-800">Dados gerais</p>
        </div>
      }
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={
        <div className="flex flex-col gap-y-4">
          <div className="flex items-center gap-x-2">
            <p className="text-[11px] leading-3 text-white-800 text-nowrap">Data fim do contrato:</p>

            <div className="flex items-center gap-x-1">
              <CalendarDaysIcon strokeWidth={1} className="size-5 text-white-400" />

              <p data-testid="contract_in_effect_until" className="text-xs text-white-400">
                {contract?.in_effect_until ? dateTransformer(contract.in_effect_until) : 'Não definida'}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-x-2">
            <p className="text-[11px] leading-3 text-white-800 text-nowrap">Região de atuação:</p>

            <div className="flex items-center gap-x-1">
              <CircleChevronDownIcon strokeWidth={1} className="size-5 min-w-5 text-white-400" />

              <p
                data-testid="contract_geo_geoables"
                className="text-xs text-white-400 flex flex-wrap gap-x-2 gap-y-1.5"
              >
                {Number(contract?.geo_geoables?.length) > 0 ? (
                  contract?.geo_geoables?.map(({ id, geo }, index) => (
                    <div className="flex" key={id}>
                      <GeoSelectOption
                        geo={geo}
                        containerProps={{
                          'data-testid': 'contract_geo_geoable_item',
                        }}
                      />

                      {contract.geo_geoables.length - 1 !== index ? ',' : ''}
                    </div>
                  ))
                ) : (
                  <p className="italic font-light">Nenhuma</p>
                )}
              </p>
            </div>
          </div>
        </div>
      }
    />
  )
}
